module.exports = __webpack_public_path__ + "09b7446c1316f0ed9ae6aba77be1154c.png";